<template>
    <div class="page-wrapper" v-loading="isLoading">
        <el-alert
            class="page-top-tips"
            type="warning"
            :closable="false"
            title="请谨慎编辑该页面，如有疑问先咨询产品和开发人员。先保存基础配置再编辑其他模块。"
        ></el-alert>
        <el-collapse v-model="actives">
            <el-collapse-item name="1">
                <template slot="title">
                    <span class="collapse-title">{{ $t("zhiji.business.base") }}</span>
                </template>
                <div class="collapse-content">
                    <BaseForm v-model="baseFormData" @change="baseChangeHandler" @submit="handlerSubmit" :businessName="businessName" />
                </div>
            </el-collapse-item>
            <el-collapse-item name="robot" v-if="isShowRobot">
                <template slot="title">
                    <span class="collapse-title">{{ $t("zhiji.business.robotSet") }}</span>
                </template>
                <div class="collapse-content">
                    <RobotForm :value="robots" :languages="baseFormData.languages" @submit="handlerSubmit" />
                </div>
            </el-collapse-item>
            <el-collapse-item name="ticket" v-if="isShowTicket">
                <template slot="title">
                    <span class="collapse-title">工单配置</span>
                </template>
                <div class="collapse-content">
                    <TicketForm :value="ticket" @submit="handlerSubmit" />
                </div>
            </el-collapse-item>
            <el-collapse-item name="im" v-if="isShowIm">
                <template slot="title">
                    <span class="collapse-title">IM配置</span>
                </template>
                <div class="collapse-content">
                    <ImForm :value="ticket" @submit="handlerSubmit" />
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
import BaseForm from "./components/BaseForm";
import RobotForm from "./components/RobotForm";
import TicketForm from "./components/TicketForm";
import ImForm from "./components/ImForm";
import { queryInfo } from "./service.js";

export default {
    components: {
        BaseForm,
        RobotForm,
        TicketForm,
        ImForm
    },
    data() {
        return {
            businessName: "",
            baseFormData: {
                languages: [],
                modules: [],
                tipFormat: 0,
                lastEditor: {}
            },
            actives: ["1", "robot", "ticket", "im"],
            robots: [],
            ticket: { sources: [] },
            im: { sources: [] },
            isLoading: false,
            hasBot: false,
        };
    },
    computed: {
        isShowRobot() {
            const showingModlues = this.baseFormData.modules;
            return showingModlues.indexOf("robot") != -1 && this.hasBot;
        },
        isShowTicket() {
            // const showingModlues = this.baseFormData.modules;
            return false; //showingModlues.indexOf("ticket") != -1;
        },
        isShowIm() {
            // const showingModlues = this.baseFormData.modules;
            return false; //showingModlues.indexOf("im") != -1;
        }
    },
    methods: {
        baseChangeHandler() {
            // TODO
        },
        async handlerSubmit() {
            const businessSetting = await this.queryInfo();
            this.$store.commit("auth/update", { businessSetting }); // 更新全局配置
        },
        async queryInfo() {
            //this.isLoading = true;
            const info = await queryInfo();

            // 基础信息
            this.businessName = info.businessName;
            const languages = this.baseFormData.languages;
            languages.splice(0, languages.length, ...info.languages);
            const modules = this.baseFormData.modules;
            modules.splice(0, modules.length, ...info.modules);
            this.baseFormData.lastEditor = {editTime: info.editTime, editor: info.editor};
            this.baseFormData.tipFormat = info.tipFormat;
            if (info.modules.find(item => item === "robot")) {
                this.hasBot = true;
            } else {
                this.hasBot = false;
            }

            // 机器人信息
            this.robots.splice(0, this.robots.length, ...info.robots);

            return info;
            //this.isLoading = false;
        }
    },
    created() {
        this.queryInfo();
    }
};
</script>

<style scoped>
.page-wrapper {
    margin: 20px 10px;
}
.page-top-tips {
    margin-bottom: 20px;
}
.collapse-title {
    margin-left: 8px;
}
.collapse-content {
    padding: 20px 10px 0;
    max-width: 900px;
}

.page-wrapper >>> .el-collapse-item__content {
    background: #fff;
}
</style>
